module.exports = __webpack_public_path__ + "static/media/cognito_dashboard.a742c96b.svg";